/*
 * INTO - Shopify Forms Shadow DOM overrides
 */

(function () {
  if (window.__intoShopifyFormsLoaded) return;
  window.__intoShopifyFormsLoaded = true;

  var STYLE_ID = 'into-shopify-forms-shadow-styles';

  var EXCLUDED_FORM_IDS = [
    'forms-root-1047990'
  ];

  var observedRoots = new WeakSet();
  var scheduledMeasurements = new WeakMap();

  var FORM_STYLES = `
    /*
     * INTO - Wspólne zmienne
     */

    :host {
      --container-border-radius: 0px !important;
      --forms-container-border-radius: 0px !important;
      --form-field-border-radius: 0px !important;
      --button-border-radius: 0px !important;

      --form-field-border: none !important;
      --form-field-border-focused: none !important;
      --container-shadow: none !important;
    }

    :host,
    :host * {
      font-family:
        'Xanh Mono',
        var(--font-body--family),
        monospace !important;
    }

    /*
     * INTO - Kontenery
     */

    :is(div, section)[class*='formContainer'],
    :is(div, section)[class*='FormContainer'],
    [class*='formContent'],
    [class*='FormContent'],
    [class*='overlay'],
    [class*='Overlay'] {
      border-radius: 0 !important;
      box-shadow: none !important;
    }

    /*
     * INTO - Heading formularza i success state
     */

    :is(
      [class*='textHeading'],
      [class*='formBannerHeading']
    ) {
      font-family:
        'Xanh Mono',
        var(--font-body--family),
        monospace !important;

      font-weight: 400 !important;
      font-style: normal !important;
      line-height: 1.1 !important;
      letter-spacing: 0.02em !important;
      text-transform: uppercase !important;
    }

    /*
     * INTO - Teksty
     */

    :is(
      [class*='textBody'],
      [class*='formDisclaimer'],
      [class*='formInputFieldLabel'],
      input,
      textarea,
      select,
      button
    ) {
      font-family:
        'Xanh Mono',
        var(--font-body--family),
        monospace !important;
    }

    /*
     * INTO - Kontener pola
     */

    [class*='formFieldContainer'],
    [class*='formFieldContainer']:focus,
    [class*='formFieldContainer']:focus-within {
      border: 0 !important;
      border-radius: 0 !important;
      outline: 0 !important;
      box-shadow: none !important;
      background: transparent !important;
    }

    /*
     * INTO - Pola tekstowe
     */

    input[class*='formInputField'],
    input[class*='FormInputField'] {
      box-sizing: border-box !important;
      width: 100% !important;
      min-width: 0 !important;
      min-height: 48px !important;

      border: 1px solid #232323 !important;
      border-radius: 0 !important;
      outline: 0 !important;
      box-shadow: none !important;

      color: #232323 !important;
      background: #fbfbfb !important;

      font-family:
        'Xanh Mono',
        var(--font-body--family),
        monospace !important;
      font-size: 16px !important;

      appearance: none !important;
    }

    input[class*='formInputField']:focus,
    input[class*='FormInputField']:focus,
    input[class*='formInputField']:focus-visible,
    input[class*='FormInputField']:focus-visible {
      border: 1px solid #232323 !important;
      border-radius: 0 !important;
      outline: 0 !important;
      box-shadow: none !important;
    }

    /*
     * INTO - Floating label
     */

    label[class*='formInputFieldLabel'],
    label[class*='FormInputFieldLabel'] {
      box-sizing: border-box !important;

      width: auto !important;
      min-width: 0 !important;
      height: auto !important;
      min-height: 0 !important;

      padding: 0 2px !important;

      border: 0 !important;
      border-radius: 0 !important;
      outline: 0 !important;
      box-shadow: none !important;

      color: #232323 !important;
      background: #fbfbfb !important;

      font-family:
        'Xanh Mono',
        var(--font-body--family),
        monospace !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 1 !important;
    }

    /*
     * INTO - Checkboxy i radio
     */

    :is(
      input[type='checkbox'],
      input[type='radio'],
      [class*='checkbox'],
      [class*='Checkbox']
    ) {
      border-radius: 0 !important;
      accent-color: #232323 !important;
    }

    /*
     * INTO - Popup
     */

    :host([data-into-form-context='popup'])
    :is(div, section)[class*='formContainer'],
    :host([data-into-form-context='popup'])
    :is(div, section)[class*='FormContainer'] {
      color: #232323 !important;
      background: #ffffff !important;
    }

    :host([data-into-form-context='popup'])
    :is(
      button[type='submit'],
      [class*='formSubmitButton'],
      [class*='FormSubmitButton'],
      [class*='submitButton'],
      [class*='SubmitButton']
    ) {
      box-sizing: border-box !important;
      min-height: 48px !important;

      border: 1px solid #232323 !important;
      border-radius: 0 !important;

      color: #fbfbfb !important;
      background: #232323 !important;

      font-family:
        'Xanh Mono',
        var(--font-body--family),
        monospace !important;
      font-weight: 400 !important;
      letter-spacing: 0.06em !important;
      text-transform: uppercase !important;

      outline: none !important;
      box-shadow: none !important;

      transition:
        color 180ms ease,
        background-color 180ms ease,
        text-decoration-color 180ms ease !important;
    }

    @media (hover: hover) {
      :host([data-into-form-context='popup'])
      :is(
        button[type='submit'],
        [class*='formSubmitButton'],
        [class*='FormSubmitButton'],
        [class*='submitButton'],
        [class*='SubmitButton']
      ):hover {
        color: #232323 !important;
        background: transparent !important;
        text-decoration: underline !important;
        text-underline-offset: 0.18em !important;
      }
    }

    /*
     * INTO - Wspólne ustawienia formularzy inline
     */

    :host([data-into-form-context^='inline']) {
      --inline-container-max-width: 100% !important;
      --container-max-w: 100% !important;
      --app-embed-width: 100% !important;
      --inline-form-alignment: stretch !important;

      display: block !important;

      box-sizing: border-box !important;
      width: 100% !important;
      min-width: 0 !important;
      max-width: none !important;

      margin-inline: 0 !important;
      overflow: visible !important;
    }

    :host([data-into-form-context^='inline'])
    :is(
      [data-testid='app-router'],
      #form-container-ref,
      section[class*='inline'],
      section[class*='formContainer'],
      [class*='gridItemContent']
    ) {
      box-sizing: border-box !important;
      width: 100% !important;
      min-width: 0 !important;
      max-width: none !important;

      margin-inline: 0 !important;
      overflow: visible !important;
    }

    :host([data-into-form-context^='inline'])
    section[class*='formContainer'] {
      grid-template-columns: minmax(0, 1fr) !important;

      color: #232323 !important;
      background: transparent !important;

      overflow: visible !important;
    }

    /*
     * INTO - Usunięcie pustej kolumny zdjęcia
     */

    :host([data-into-form-context^='inline'])
    [class*='gridItem']:not([class*='gridItemContent']) {
      display: none !important;
    }

    /*
     * INTO - Formularz inline
     */

    :host([data-into-form-context^='inline'])
    form[class*='formFieldset'] {
      position: relative !important;

      box-sizing: border-box !important;
      width: 100% !important;
      min-width: 0 !important;
      max-width: none !important;

      padding: 2px !important;
      overflow: visible !important;
    }

    /*
     * INTO - Techniczny element poza layoutem
     */

    :host([data-into-form-context^='inline'])
    form[class*='formFieldset']
    > div:has(> shop-lead-capture) {
      position: absolute !important;

      width: 0 !important;
      height: 0 !important;

      overflow: hidden !important;
      pointer-events: none !important;
    }

    :host([data-into-form-context^='inline'])
    form[class*='formFieldset']
    > [class*='formFieldContainer'] {
      box-sizing: border-box !important;

      width: 100% !important;
      min-width: 0 !important;

      border: 0 !important;
      border-radius: 0 !important;
      outline: 0 !important;
      box-shadow: none !important;

      background: transparent !important;
    }

    :host([data-into-form-context^='inline'])
    form[class*='formFieldset']
    > [class*='formFieldContainer']:focus,
    :host([data-into-form-context^='inline'])
    form[class*='formFieldset']
    > [class*='formFieldContainer']:focus-within {
      border: 0 !important;
      outline: 0 !important;
      box-shadow: none !important;
    }

    /*
     * INTO - Przycisk formularza inline
     */

    :host([data-into-form-context^='inline'])
    form[class*='formFieldset']
    > button[type='submit'] {
      box-sizing: border-box !important;

      width: max-content !important;
      min-width: max-content !important;
      min-height: 48px !important;

      margin: 0 !important;
      padding: 0 22px !important;

      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;

      border: 1px solid #232323 !important;
      border-radius: 0 !important;

      color: #232323 !important;
      background: transparent !important;

      font-family:
        'Xanh Mono',
        var(--font-body--family),
        monospace !important;
      font-weight: 400 !important;
      letter-spacing: 0.06em !important;
      text-transform: uppercase !important;

      text-decoration-line: underline !important;
      text-decoration-color: transparent !important;
      text-decoration-thickness: 0.075em !important;
      text-underline-offset: 0.18em !important;

      outline: none !important;
      box-shadow: none !important;

      transition:
        color 180ms ease,
        background-color 180ms ease,
        text-decoration-color 180ms ease !important;
    }

    @media (hover: hover) {
      :host([data-into-form-context^='inline'])
      form[class*='formFieldset']
      > button[type='submit']:hover {
        border-color: #232323 !important;

        color: #232323 !important;
        background: transparent !important;

        text-decoration-color: currentcolor !important;
      }
    }

    :host([data-into-form-context^='inline'])
    form[class*='formFieldset']
    > button[type='submit']:focus-visible {
      border-color: #232323 !important;

      color: #232323 !important;
      background: transparent !important;

      text-decoration-color: currentcolor !important;

      outline: none !important;
      box-shadow: none !important;
    }

    :host([data-into-form-context^='inline'])
    form[class*='formFieldset']
    > button[type='submit'][aria-disabled='true'] {
      opacity: 0.5 !important;
    }

    /*
     * INTO - Desktop
     */

    @media screen and (min-width: 750px) {
      :host([data-into-form-context^='inline'])
      form[class*='formFieldset'] {
        display: grid !important;

        grid-template-columns:
          minmax(0, 1fr)
          max-content !important;

        align-items: stretch !important;

        column-gap: 10px !important;
        row-gap: 0 !important;
      }

      :host([data-into-form-context^='inline'])
      form[class*='formFieldset']
      > [class*='formFieldContainer'] {
        grid-column: 1 !important;
        grid-row: 1 !important;
      }

      :host([data-into-form-context^='inline'])
      form[class*='formFieldset']
      > button[type='submit'] {
        grid-column: 2 !important;
        grid-row: 1 !important;

        align-self: stretch !important;
        justify-self: start !important;
      }
    }

    /*
     * INTO - Mobile
     */

    @media screen and (max-width: 749px) {
      :host([data-into-form-context^='inline'])
      form[class*='formFieldset'] {
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;

        gap: 10px !important;
      }

      :host([data-into-form-context^='inline'])
      form[class*='formFieldset']
      > button[type='submit'] {
        width: max-content !important;
        min-height: 44px !important;

        padding: 10px 18px !important;

        align-self: flex-start !important;
      }
    }

    /*
     * INTO - Success state bez zmiany wysokości
     */

    :host([data-into-form-context^='inline'])
    #app-embed[data-current-step='success']
    section[class*='formContainer'] {
      box-sizing: border-box !important;

      min-height:
        var(--into-form-stable-height, 190px)
        !important;

      display: grid !important;
      grid-template-columns: minmax(0, 1fr) !important;
      align-items: center !important;

      overflow: visible !important;
    }

    :host([data-into-form-context^='inline'])
    #app-embed[data-current-step='success']
    [class*='gridItemContent'] {
      box-sizing: border-box !important;

      width: 100% !important;
      min-width: 0 !important;
      min-height: 100% !important;

      display: flex !important;
      flex-direction: column !important;
      justify-content: center !important;
      align-items: stretch !important;
    }

    :host([data-into-form-context^='inline'])
    #app-embed[data-current-step='success']
    [data-testid='banner-success'] {
      box-sizing: border-box !important;

      width: 100% !important;
      min-width: 0 !important;

      display: flex !important;
      flex-direction: column !important;
      justify-content: center !important;

      margin-block: auto !important;
    }

    /*
     * INTO - Success w stopce
     */

    :host([data-into-form-context='inline-footer'])
    #app-embed[data-current-step='success']
    [data-testid='banner-success'] {
      align-items: flex-start !important;
      text-align: left !important;
    }

    /*
     * INTO - Success na stronie hasła
     */

    :host([data-into-form-context='inline-password'])
    #app-embed[data-current-step='success']
    [data-testid='banner-success'] {
      align-items: center !important;
      text-align: center !important;
    }

    /*
     * INTO - Success w pozostałych formularzach inline
     */

    :host([data-into-form-context='inline-generic'])
    #app-embed[data-current-step='success']
    [data-testid='banner-success'] {
      align-items: center !important;
      text-align: center !important;
    }

    /*
     * INTO - Heading success state
     */

    :host([data-into-form-context^='inline'])
    [class*='formBannerHeading'] {
      font-family:
        'Xanh Mono',
        var(--font-body--family),
        monospace !important;

      font-weight: 400 !important;
      font-style: normal !important;
      line-height: 1.1 !important;
      letter-spacing: 0.02em !important;
      text-transform: uppercase !important;
    }

    /*
     * INTO - Przycisk kopiowania kodu
     */

    :host([data-into-form-context^='inline'])
    button[class*='copyToClipboardButton'] {
      box-sizing: border-box !important;

      border: 1px solid #232323 !important;
      border-radius: 0 !important;

      color: #232323 !important;
      background: transparent !important;

      font-family:
        'Xanh Mono',
        var(--font-body--family),
        monospace !important;
      font-weight: 400 !important;

      outline: none !important;
      box-shadow: none !important;
    }

    @media (hover: hover) {
      :host([data-into-form-context^='inline'])
      button[class*='copyToClipboardButton']:hover {
        color: #232323 !important;
        background: transparent !important;
        text-decoration: underline !important;
        text-underline-offset: 0.18em !important;
      }
    }

    :host([data-into-form-context^='inline'])
    button[class*='copyToClipboardButton']
    svg {
      fill: currentcolor !important;
    }

    /*
     * INTO - Teaser popupu
     */

    :is([class*='teaser'], [class*='Teaser']) {
      border-radius: 0 !important;
    }

    :is([class*='teaser'], [class*='Teaser'])
    button {
      border-radius: 0 !important;

      color: #fbfbfb !important;
      background: #232323 !important;

      font-family:
        'Xanh Mono',
        var(--font-body--family),
        monospace !important;
    }

    /*
     * INTO - Linki i błędy
     */

    :is(a, [class*='link'], [class*='Link']) {
      color: inherit !important;
      text-underline-offset: 0.18em !important;
    }

    :is([class*='error'], [class*='Error']) {
      color: #8a1f1b !important;
    }

    /*
     * INTO - Ograniczenie animacji
     */

    @media (prefers-reduced-motion: reduce) {
      * {
        transition-duration: 0.01ms !important;
      }
    }
          /*
     * INTO - Pozycja przycisku zamykania popupu
     */

    :host([data-into-form-context='popup'])
    [class*='formContainerCloseButtonPosition'] {
          top: calc(var(--forms-padding-top) - 25px) !important;
    right: calc(var(--forms-padding-right) - 20px)!important;

    }
  `;

  /*
   * INTO - Szukanie zewnętrznego wrappera formularza inline
   */

  function findInlineWrapper(host) {
    var currentHost = host;

    while (currentHost) {
      var wrapper = null;

      if (typeof currentHost.closest === 'function') {
        wrapper = currentHost.closest(
          "[data-form-root='true'][id*='forms_inline']"
        );
      }

      if (wrapper) return wrapper;

      var parentRoot = currentHost.getRootNode();

      currentHost =
        parentRoot instanceof ShadowRoot
          ? parentRoot.host
          : null;
    }

    return null;
  }

  /*
   * INTO - Wykluczone formularze
   */

  function isExcludedForm(host) {
    var inlineWrapper = findInlineWrapper(host);

    if (!inlineWrapper) return false;

    var formId = inlineWrapper.getAttribute(
      'data-forms-id'
    );

    return EXCLUDED_FORM_IDS.indexOf(formId) !== -1;
  }

  /*
   * INTO - Rozpoznawanie kontekstu
   */

  function getFormContext(host) {
    var inlineWrapper = findInlineWrapper(host);

    if (inlineWrapper) {
      if (inlineWrapper.closest('footer')) {
        return 'inline-footer';
      }

      if (
        inlineWrapper.closest('.password-main-content') ||
        window.location.pathname === '/password'
      ) {
        return 'inline-password';
      }

      return 'inline-generic';
    }

    var currentHost = host;

    while (currentHost) {
      var savedContext = currentHost.getAttribute(
        'data-into-form-context'
      );

      if (savedContext) return savedContext;

      var parentRoot = currentHost.getRootNode();

      currentHost =
        parentRoot instanceof ShadowRoot
          ? parentRoot.host
          : null;
    }

    return 'popup';
  }

  /*
   * INTO - Sprawdzenie Shadow Root
   */

  function isShopifyFormsRoot(root, host) {
    if (!(root instanceof ShadowRoot)) {
      return false;
    }

    if (!(host instanceof HTMLElement)) {
      return false;
    }

    if (
      !host.matches(
        'shopify-forms-embed, shop-lead-capture'
      )
    ) {
      return false;
    }

    return true;
  }

  /*
   * INTO - Usuwanie zmian z wykluczonego formularza
   */

  function clearOverrides(root, host) {
    var style = root.getElementById(STYLE_ID);

    if (style) style.remove();

    host.removeAttribute(
      'data-into-shopify-forms-root'
    );

    host.removeAttribute(
      'data-into-form-context'
    );

    host.style.removeProperty(
      '--into-form-stable-height'
    );
  }

  /*
   * INTO - Pomiar wysokości formularza
   */

  function scheduleStableHeightMeasurement(
    root,
    host,
    context
  ) {
    if (context.indexOf('inline') !== 0) return;

    if (scheduledMeasurements.has(host)) {
      window.cancelAnimationFrame(
        scheduledMeasurements.get(host)
      );
    }

    var frameId = window.requestAnimationFrame(
      function () {
        scheduledMeasurements.delete(host);

        var appRoot = root.querySelector(
          "#app-embed[data-current-step='form']"
        );

        if (!appRoot) return;

        var container = appRoot.querySelector(
          "section[class*='formContainer']"
        );

        if (!container) return;

        var height = Math.ceil(
          container.getBoundingClientRect().height
        );

        if (height > 0) {
          host.style.setProperty(
            '--into-form-stable-height',
            height + 'px'
          );
        }
      }
    );

    scheduledMeasurements.set(host, frameId);
  }

  /*
   * INTO - Wstrzykiwanie stylów
   */

  function injectStyles(root) {
    var host = root.host;

    if (!isShopifyFormsRoot(root, host)) return;

    if (isExcludedForm(host)) {
      clearOverrides(root, host);
      return;
    }

    var context = getFormContext(host);

    host.setAttribute(
      'data-into-shopify-forms-root',
      ''
    );

    host.setAttribute(
      'data-into-form-context',
      context
    );

    if (!root.getElementById(STYLE_ID)) {
      var style = document.createElement('style');

      style.id = STYLE_ID;
      style.textContent = FORM_STYLES;

      root.appendChild(style);
    }

    scheduleStableHeightMeasurement(
      root,
      host,
      context
    );
  }

  /*
   * INTO - Obserwowanie Shadow Root
   */

  function observeShadowRoot(root) {
    if (observedRoots.has(root)) return;

    observedRoots.add(root);

    var observer = new MutationObserver(
      function () {
        scan(root);
      }
    );

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-current-step']
    });
  }

  /*
   * INTO - Skanowanie dokumentu i Shadow Roots
   */

  function scan(root) {
    root = root || document;

    if (root instanceof ShadowRoot) {
      observeShadowRoot(root);
      injectStyles(root);
    }

    if (
      root instanceof Element &&
      root.shadowRoot
    ) {
      scan(root.shadowRoot);
    }

    if (typeof root.querySelectorAll !== 'function') {
      return;
    }

    var elements = root.querySelectorAll('*');

    for (
      var index = 0;
      index < elements.length;
      index += 1
    ) {
      if (elements[index].shadowRoot) {
        scan(elements[index].shadowRoot);
      }
    }
  }

  /*
   * INTO - Pierwsze uruchomienie
   */

  scan();

  /*
   * INTO - Elementy doładowane po starcie strony
   */

  var pageObserver = new MutationObserver(
    function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node instanceof Element) {
            scan(node);
          }
        });
      });
    }
  );

  pageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  /*
   * INTO - Shopify Theme Editor
   */

  document.addEventListener(
    'shopify:section:load',
    function () {
      scan();
    }
  );

  /*
   * INTO - Powrót przez historię przeglądarki
   */

  window.addEventListener(
    'pageshow',
    function () {
      scan();
    }
  );

  /*
   * INTO - Ponowny pomiar po zmianie szerokości
   */

  var resizeTimer;

  window.addEventListener(
    'resize',
    function () {
      window.clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(
        function () {
          scan();
        },
        150
      );
    }
  );

  /*
   * INTO - Zabezpieczenie dla późnego ładowania aplikacji
   */

  var attempts = 0;

  var retryTimer = window.setInterval(
    function () {
      scan();
      attempts += 1;

      if (attempts >= 20) {
        window.clearInterval(retryTimer);
      }
    },
    500
  );
})();